import React,{useEffect} from 'react'
import './VerticalStepper.css'

function VerticalStepper({ steps, activeStep }) {

  function getStepClass(step) {
    let cls = 'step';
    if(activeStep === step) {
      cls += ' step-active';
    }
    else if(activeStep > step) {
      cls += ' step-done';
    }
    else {
      cls += ' step-inactive'
    }
    return cls;
  }

  return(
    <div className="steps-container">
    {
      steps.map((o, index) =>
        <div className={getStepClass(index)} key={index}>
          <div>
              <div className="circle">{index + 1}</div>
          </div>
          <div>
              <div className="title">{o.label}</div>
              {/* <div class="caption">This is description of second step.</div> */}
          </div>

          {/* <div>
              <div className="circle">{index + 1}</div>
              <div className="label">{o.label}</div>
          </div>
          { index < steps.length - 1 && <div className="line"></div> } */}
        </div>
      )
    }
    </div>
  );
}


export default VerticalStepper;